import { useState } from 'react'

import { useSelector, useDispatch } from 'react-redux'
import Button from 'components/forms/Button'
import NavDropdown from 'components/navbar/NavDropdown'
import { setMode } from 'store/login-modal/actions'
import { toggleModal, logout } from 'store/ui/actions'
import styles from './styles/NavLogin.css'
import HoverLink from './HoverLink'
import NavAvatar from '../misc/NavAvatar'
import CircleSpinner from '../misc/CircleSpinner'
import * as userjot from '../../lib/userjot'
import classNames from '../../../node_modules/classnames/index'
import { getLocalStorage } from '../../lib/get-local-storage'

const NavLogin = ({
  className = '',
  avatarBg = 'gray',
  buttonColor = 'transparent',
  showSignup,
  hideAuthButtons = false,
  signupClassName = '',
  loginClassName = '',
  avatarWrapperMobile = '',
  navBarButtons = ''
}) => {
  const user = useSelector(({ ui: { user } }) => user)
  const fetchingUser = useSelector(({ ui: { fetchingUser } }) => fetchingUser)
  const extensionLoaded = useSelector(({ ui }) => ui.extensionLoaded)
  const browser = useSelector(({ ui }) => ui.browser)

  const dispatch = useDispatch()
  const [hasToken] = useState(() => {
    const localStorage = getLocalStorage()
    return !!localStorage?.getItem('apiToken')
  })

  const SUPPORTED_BROWSERS = ['chrome', 'firefox', 'safari']

  const links = {
    chrome: CONFIG.plugin.chromeLink,
    firefox: CONFIG.plugin.firefoxLink,
    safari: CONFIG.plugin.safariLink
  }

  const browserName = SUPPORTED_BROWSERS.includes(browser?.name) ? browser?.name : 'chrome'

  const handleFeedbackClick = () => {
    userjot.openWidget()
  }

  const setAvatarItems = () => {
    const items = [
      {
        name: (
          <>
            <span className={styles.navUserName}>{user.name}</span>
            <span className={styles.navUserEmail}>{user.email}</span>
          </>
        ),
        href: ''
      },
      {
        name: 'My Profile',
        itemImg: `${CONFIG.assetsBaseURL}/images/icons/person_info.svg`,
        href: `/users/${user.slug}`
      },
      {
        name: 'Account Settings',
        itemImg: `${CONFIG.assetsBaseURL}/images/icons/badge.svg`,
        href: `/users/${user.slug}/account-settings`
      },
      user?.admin && {
        name: 'Admin',
        itemImg: `${CONFIG.assetsBaseURL}/images/icons/edit.svg`,
        href: '/admin'
      },
      user?.admin && {
        name: 'Manage Licenses',
        itemImg: `${CONFIG.assetsBaseURL}/images/icons/organization_icon.svg`,
        href: '/manage-licenses'
      },
      user?.subscription?.plan === 'team' && {
        name: 'Manage Team',
        itemImg: `${CONFIG.assetsBaseURL}/images/icons/organization_icon.svg`,
        href: '/manage-licenses'
      },
      user?.organizationLicense && {
        name: 'Submit Feedback',
        itemImg: `${CONFIG.assetsBaseURL}/images/icons/chat-icon.svg`,
        onClick: handleFeedbackClick
      },
      {
        name: 'Sign Out',
        itemImg: `${CONFIG.assetsBaseURL}/images/icons/sign_out_icon.svg`,
        onClick: () => dispatch(logout()),
        href: '#'
      }
    ].filter(Boolean)

    const installExtension = {
      item: {
        name: 'Install Extension',
        itemImg: `${CONFIG.assetsBaseURL}/images/icons/${browserName}.svg`,
        href: links[browserName]
      },
      index: 2
    }

    return !fetchingUser && !extensionLoaded
      ? [...items.slice(0, installExtension.index), installExtension.item, ...items.slice(installExtension.index)]
      : items
  }

  const avatarItems = user ? setAvatarItems() : []

  const handleSignin = () => {
    dispatch(setMode('login'))
    dispatch(toggleModal('login'))
  }

  const handleSignup = () => {
    dispatch(setMode('register'))
    dispatch(toggleModal('login'))
  }

  //
  // Show loading indicator only if we expect a logged-in user
  //
  if (fetchingUser && hasToken) {
    return <CircleSpinner size={25} />
  }
  if (user?.email) {
    return (
      <NavDropdown
        dropdownClassName={classNames(styles.avatarWrapper, avatarWrapperMobile)}
        items={avatarItems}
        menuOffset={[-45, 12]}
      >
        <NavAvatar src={user.avatar} bg={avatarBg} />
      </NavDropdown>
    )
  }

  if (hideAuthButtons) return null

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      handleSignup()
    }
  }

  const authButtons = showSignup ? (
    <div className={classNames(styles.buttonLayout, className, navBarButtons, loginClassName)}>
      <HoverLink onClick={handleSignin}>Log In</HoverLink>
      <Button
        className={`${styles.button} ${signupClassName}`}
        onClick={handleSignup}
        color={buttonColor}
        bold
        small
        onKeyDown={handleKeyDown}
      >
        Start Free Trial
      </Button>
    </div>
  ) : (
    <div className={styles.buttonLayout}>
      <Button className={styles.button} onClick={handleSignin} color={buttonColor} bold small>
        Log in
      </Button>
    </div>
  )
  return authButtons
}

export default NavLogin
